<div class="privacy-glass-modal">
    <!-- Modal Body -->
    <div class="modal-body privacy-body">
        <div class="privacy-header d-flex align-items-center gap-3 mb-2 justify-content-center p-2">
            <div class="rounded-circle d-flex align-items-center shadow-sm flex-shrink-0 justify-content-center"
                style="width: 40px; height: 40px; background: linear-gradient(135deg, #FF9933 0%, #FF512F 100%);">
                <i class="bi bi-shield-fill-check text-white"></i>
            </div>
            <h2 class="modal-title divine-font fw-bold mb-0">Privacy Policy</h2>
        </div>

        <div class="privacy-content">
            <p>
                NextPooja.com is property of Shivam CloudSoft Solutions LLP, an Indian Company registered under the
                Companies Act, 2013. We recognises the importance of maintaining your privacy. We value your privacy and
                appreciate your trust in us. This Policy describes how we treat user information we collect on
                https://www.NextPooja.com, our other client websites and our mobile applications. This Privacy Policy
                applies to
                current and former visitors to our website and to our online customers. By visiting and/or using our
                website,
                you agree to this Privacy Policy.
            </p>

            <h3>Information we collect</h3>
            <p>Contact information. We might collect your name, email, mobile number, phone number, street, city, state,
                pincode, country and ip address.</p>

            <h3>Payment and billing information.</h3>
            <p>We might collect your name, address and payment method when you order anything in the platform. We NEVER
                store
                your Credit Card/Debit Card number, expiry date or other details pertaining to your Credit/Debit Card in
                our
                Application. While you opt remember card option, we could save sensitive card information in the secure
                card
                vault of our PCI DSS certified payment partner. On your next checkout, you no longer need to re-enter
                the card
                details and can enjoy a more seamless experience. Our payment partner do not store the customer's CVV
                number and
                are fully PCI-DSS Compliant. So at the next checkout you need to enter the cvv of your card. You will be
                redirected to the bank page to enter the OTP issued by the bank to your registered mobile number.</p>

            <h3>Demographic information.</h3>
            <p>We may collect demographic information about you, temples you like, location, or any other information
                provided
                by your during the use of our website. We might collect this as a part of a survey also.</p>

            <h3>Other information.</h3>
            <p>If you use our website, we may collect information about your IP address and the browser you're using. We
                might
                look at what site you came from, duration of time spent on our website, pages accessed or what site you
                visit
                when you leave us. We might also collect the type of mobile device you are using, or the version of the
                operating system your computer or device is running.</p>

            <h3>We collect information in different ways.</h3>

            <h4>We collect information directly from you.</h4>
            <p>We collect information directly from you when you register at our site or buy anything.</p>

            <h4>We collect information from you passively.</h4>
            <p>We use tracking tools like Google Analytics, Google Webmaster, browser cookies and web beacons for
                collecting
                information about your usage of our website.</p>

            <h4>We get information about you from third parties.</h4>
            <p>For example, if you use an integrated social media feature on our websites. The third-party social media
                site
                will give us certain information about you. This could include your name and email address.</p>

            <h3>Use of your personal information</h3>

            <h4>We use information to contact you:</h4>
            <p>We might use the information you provide to contact you for confirmation of a purchase on our website or
                for
                other promotional purposes.</p>

            <h4>We use information for security purposes.</h4>
            <p>We may use information to protect our company, our customers, or our websites.</p>

            <h4>We use information for marketing purposes.</h4>
            <p>We might send you information about special promotions or offers. We might also tell you about new
                features or
                products. These might be our own offers or products, or third-party offers or products we think is
                relevant for
                the platform. Or, for example, if you buy/book puja or other services from us we'll enroll you in our
                newsletter.</p>

            <h4>We use information to send you transactional communications.</h4>
            <p>We might send you emails or SMS about your purchases or its status. We use information as otherwise
                permitted by
                law. Sharing of information with third-parties</p>

            <h4>We will share information with third parties who perform services on our behalf.</h4>
            <p>We share information with vendors who help us manage our online registration process or payment
                processors or
                transactional message processors.</p>

            <h4>We will share information with our business partners.</h4>
            <p>This includes a temple, priests etc. Our partners use the information we give them as described in their
                privacy
                policies.</p>

            <h4>We may share information if we think we have to in order to comply with the law or to protect ourselves.
            </h4>
            <p>We will share information to respond to a court order or subpoena. We may also share it if a government
                agency or
                investigatory body requests. Or, we might also share information when we are investigating potential
                fraud.</p>

            <h4>We may share information with any successor to all or part of our business.</h4>
            <p>For example, if part of our business is sold we may give our customer list as part of that transaction.
                We may
                share your information for reasons not described in this policy. We will tell you before we do this.</p>

            <h3>Third party sites</h3>
            <p>If you click on one of the links to third party websites, you may be taken to websites we do not control.
                This
                policy does not apply to the privacy practices of those websites. Read the privacy policy of other
                websites
                carefully. We are not responsible for these third party sites. If you have any questions about this
                Policy or
                other privacy concerns, you can also email us at support@clouddimension.in</p>

            <h3>Updates to this policy</h3>
            <p>This Privacy Policy was last updated on 10.09.2021. From time to time we may change our privacy
                practices. We
                will notify you of any material changes to this policy as required by law. We will also post an updated
                copy on
                our website. Please check our site periodically for updates.</p>

            <h3>Jurisdiction</h3>
            <p>If you choose to visit the website, your visit and any dispute over privacy is subject to this Policy and
                the
                website's terms of use. In addition to the foregoing, any disputes arising under this Policy shall be
                governed
                by the laws of India.</p>
        </div>

    </div>

    <!-- Modal Footer -->
    <div class="modal-footer privacy-footer d-flex justify-content-end">
        <button type="button" class="btn btn-glass-cancel" data-bs-dismiss="modal" (click)="cancel()">Cancel</button>
        <button type="button" class="btn btn-glass-agree" (click)="confirm()">Agree</button>
    </div>
</div>